import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-diagram"
}
const _hoisted_2 = {
  width: "150",
  height: "150"
}
const _hoisted_3 = ["stroke", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_4 = { class: "v-diagram__info" }
const _hoisted_5 = { class: "v-diagram__label" }
const _hoisted_6 = { class: "v-diagram__stats" }
const _hoisted_7 = { class: "v-diagram__item" }
const _hoisted_8 = {
  key: 1,
  class: "v-diagram"
}
const _hoisted_9 = { class: "v-diagram__info" }
const _hoisted_10 = { class: "v-diagram__label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "v-diagram__item" }, "Нет отчетов для статистики", -1)

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VDiagram',
  props: {
    items: null,
    label: null,
    colorScheme: null,
    keyColors: null
  },
  setup(__props: any) {

const props = __props as { 
  items?: { title: string, value: number }[], 
  label?: string,
  colorScheme?: keyof typeof colorSchemes,
  keyColors?: { [key: string]: string }
}



const colorScheme = computed(() => {
  return colorSchemes[props.colorScheme || "default"]
})

const getColor = (item: any, index: number) => {
  if (item.color) return item.color
  if (props.keyColors) {
    return props.keyColors[item.title]
  }
  return colorScheme.value[index]
}

const sum = computed(() => {
  if (!props.items) return 0
  return props.items.reduce((sum, val) => sum + val.value, 0)
})

const dash = computed(() => {
  if (!props.items) return []
  let s = 376/4
  return props.items.map(item => {
    const val = (376 * item.value / sum.value)
    s += val
    return [
      val + " " + (376-val),
      s
    ]
  })
})

const colorSchemes = {
  default: [
    "#35BEE9",
    "#2BE78D",
    "#D857E3",
    "#A557E3",
    "#EF9275",
    "#5761E3",
    "#35BEE9",
    "#2BE78D",
    "#D857E3",
    "#A557E3",
    "#EF9275",
    "#5761E3",
  ],
  bright: [
    "#6CCB86",
    "#C8EF75",
    "#EFEA75",
    "#EFC575",
    "#EF7575",
    "#6CCB86",
    "#C8EF75",
    "#EFEA75",
    "#EFC575",
    "#EF7575"
  ]
}


return (_ctx: any,_cache: any) => {
  return (props.items && props.items.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("circle", {
              cx: "75",
              cy: "75",
              r: "60",
              fill: "none",
              "stroke-width": "26",
              stroke: getColor(item, index),
              "stroke-dasharray": _unref(dash)[index][0],
              "stroke-dashoffset": _unref(dash)[index][1]
            }, null, 8, _hoisted_3))
          }), 256))
        ])),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(props.label), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "diagram__marker",
                  style: _normalizeStyle({ backgroundColor: getColor(item, index) })
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(item.title) + " (" + _toDisplayString((item.value / _unref(sum) * 100).toFixed() + "%") + ") ", 1)
              ]))
            }), 256))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(props.label), 1),
          _hoisted_11
        ])
      ]))
}
}

})